import 'choerodon-ui/lib/tag/style';
import 'choerodon-ui/lib/checkbox/style';
import 'choerodon-ui/lib/grid/style';
import './index.less';
